import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isEmpty } from '../../../utils/transformValueUtils';
import FieldWithLabelAndValue from './atomic/FieldWithLabelAndValue';
import { HIGHLIGHT_CONTACT_EMAIL } from '../../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactEmail = ({
  value
}) => {
  const emailLink = isEmpty(value) ? ` ${value}` : /*#__PURE__*/_jsx(UILink, {
    href: `mailto: ${value}`,
    children: ` ${value}`
  });
  return /*#__PURE__*/_jsx(FieldWithLabelAndValue, {
    "data-test-id": HIGHLIGHT_CONTACT_EMAIL,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "highlightCard.propertyLabels.contactEmail"
    }),
    value: emailLink
  });
};
export default ContactEmail;